var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer skinc-container"},[_c('div',{staticClass:"footer-top"},[_c('div',{staticClass:"footer-gnb-wrapper"},[_c('FooterGnb')],1),_c('FooterRight')],1),_c('FooterBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }